import React, {useCallback, useState} from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../style/styleConsts";
import {SecondaryButton} from "../../elements/Buttons";
import {logAction} from "../../../logging/logEvent";

const Container = styled.div`
    display: flex;
    margin-left: 30px;
`;

const SearchInput = styled.input`
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: ${subduedTextColour};
    }
    &::-moz-placeholder { /* Firefox 19+ */
        color: ${subduedTextColour};
    }
    &::-ms-input-placeholder { /* IE 10+ */
        color: ${subduedTextColour};
    }
`;

const Button = styled(SecondaryButton)`
    height: 22px;
    line-height: 22px;
    margin-top: 0;
    margin-left: 6px;
`;

const SearchBox = ({ourProgrammeContext, applyFilter}) => {
    const [typedFilter, setTypedFilter] = useState("");
    const onFilterChange = useCallback(event => {
        setTypedFilter(event.target.value);
    }, []);
    const doApplyFilter = useCallback(() => {
        const {firstGroupingName, secondGroupingName, portfolioId, portfolioName, companyWithinPortfolioId: companyId} = ourProgrammeContext.context();

        logAction({
            type: "SEARCH_TRIGGERED",
            searchQuery: typedFilter,
            companyId,
            portfolioId,
            portfolioName,
            firstGroupingName,
            secondGroupingName
        });
        applyFilter(typedFilter);
    }, [typedFilter, ourProgrammeContext, applyFilter]);
    const onKeyPress = useCallback(event => {
        if (event.key === "Enter") {
            doApplyFilter();
        }
    }, [doApplyFilter]);

    return (
        <Container className="t-search-box">
            <SearchInput placeholder="Search by name"
                         value={typedFilter}
                         onKeyPress={onKeyPress}
                         onChange={onFilterChange}/>
            <Button className="t-apply-button" onClick={doApplyFilter}>Apply</Button>
        </Container>
    );
};

export default SearchBox;
